<template>
  <div class="materia-watch-page">
    <div class="group-list">
      <h3 class="head">材料信息</h3>
      <el-row :gutter="20">
        <el-col :md="8">
          <div class="grid-content">项目名称：{{fileGroup.projectName}}</div>
        </el-col>
        <el-col :md="8">
          <div
            class="grid-content"
          >上传时间：{{fileGroup.createTime| convertTime('YYYY-MM-DD HH:mm:ss')}}</div>
        </el-col>
        <el-col :md="8">
          <div class="grid-content">
            完成时间：
            <span
              v-if="fileGroup.finishTime"
            >{{fileGroup.finishTime | convertTime('YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
        </el-col>
        <el-col :md="8">
          <div class="grid-content">患者来源：{{getSource(fileGroup.patientSource)}}</div>
        </el-col>
        <el-col :md="8">
          <div class="grid-content">
            状态：
            <el-tag effect="dark" type="success" v-if="getStatus(fileGroup.status)=='已完成'">已完成</el-tag>
            <el-tag effect="dark" type="danger" v-else>{{getStatus(fileGroup.status)}}</el-tag>
          </div>
        </el-col>
        <el-col :md="8" v-if="fileGroup.reason">
          <div class="grid-content">备注：{{fileGroup.reason}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="group-list">
      <h3 class="head">患者信息</h3>
      <el-row :gutter="20">
        <el-col :md="8">
          <div class="grid-content">援助方式：{{fileGroup.patientMode}}</div>
        </el-col>
        <el-col :md="8">
          <div class="grid-content">患者姓名：{{fileGroup.patientName}}</div>
        </el-col>
        <el-col :md="8">
          <div class="grid-content">身份证号：{{fileGroup.idcard}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="group-list">
      <h3 class="head">材料条目</h3>
      <el-row :gutter="30">
        <el-col :span="24">
          <div class="grid-content">
            按领药阶段次数：
            <el-tag
              :type="clickPhase == '全部'?'':'info'"
              class="tag-list-box1"
              @click="handlePhase('全部')"
            >全部({{AllphaseNum}})</el-tag>
            <el-tag
              @click="handlePhase(child)"
              class="tag-list-box"
              v-for="(child,index) in files"
              :key="index"
              :type="clickPhase.phase == child.phase&&clickPhase.times == child.times?'':'info'"
            >{{child.phase*1?'第'+child.phase+'阶段'+"第"+child.times+"次领药":"无阶段"}}({{child.fileNum}})</el-tag>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content">
            按材料类别：
            <el-tag
              :type="clickCheck == '全部'?'':'info'"
              class="tag-list-box1"
              @click="handleCheck('全部')"
            >全部({{AllphaseNum}})</el-tag>
            <el-tag
              class="tag-list-box"
              v-for="(child,index) in allCheck"
              :key="index"
              :type="clickCheck == child.item?'':'info'"
              @click="handleCheck(child.item)"
            >{{child.item}}({{child.fileNum}})</el-tag>
          </div>
        </el-col>
        <el-col
          :md="6"
          v-for="(ele,index) in perfilesImage[listQuery.pageIndex-1]"
          :key="index"
          class="file-list"
        >
          <div class="grid-img-box">
            <el-image
              :src="ele.url"
              fit="cover"
              style="height:270px;"
              :preview-src-list="srcList"
              @click="openImage(ele.url)"
            ></el-image>
            <p class="clearfix">
              <span class="fl">{{ele.linkSource}}</span>
            </p>
            <p>{{ele.phase*1?'第'+ele.phase+'阶段'+"第"+ele.times+"次领药":"无阶段"}}-{{ele.item}}</p>
            <p>{{ele.fileName}}</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.pageIndex"
      :limit.sync="listQuery.pageSize"
      @pagination="getList"
    />
  </div>
</template>

<script>
import {
  groudetail,
  patientquery,
  filedetail,
  fileupdate,
  queryDetail,
  updateByManual,
  updateByPap
} from "@/api/manage";
import { all } from "q";
import Pagination from "@/components/Pagination";
export default {
  inject: ["reload"],
  data() {
    return {
      total: 0, // 总个数
      listQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      id: null,
      projectId: null,
      fileGroup: {},
      files: [],
      srcList: [],
      allCheck: [], //所有条目
      filesImage: [], //放下面的文件图片用于筛选
      perfilesImage: [], //每页的图片数组
      AllphaseNum: 0, //全部阶段数目
      AllcheckNum: 0, //全部条目数目
      clickPhase: "全部", //点击的阶段
      clickCheck: "全部", //点击的条目
      formInline: {},
      patientData: [],
      patientAllDetail: {}, //患者基本和系统信息
      activeName: "first",
      checkitemForm: {
        item: null,
        phase: null
      },
      tabelInfo: [], //档案信息
      patientTotal: 0, //患者个数
      currentPage1: 1,
      formInline: {
        patientName: "",
        idcard: ""
      },
      currentRow: null
    };
  },
  components: { Pagination },
  computed: {
    patientstatus() {
      switch (this.fileGroup.status) {
        case 50:
          return "失败";
          break;
        case 0:
          return "初始化";
          break;
        case 20:
          return "匹配中";
          break;
        case 30:
          return "已完成";
          break;
      }
    }
  },
  created() {
    this.id = this.$route.params.id * 1;
    this.initData();
  },
  methods: {
    // 切割数组
    chunk(arr, size) {
      var objArr = new Array();
      var index = 0;
      var objArrLen = arr.length / size;
      for (var i = 0; i < objArrLen; i++) {
        var arrTemp = new Array();
        for (var j = 0; j < size; j++) {
          arrTemp[j] = arr[index++];
          if (index == arr.length) {
            break;
          }
        }
        objArr[i] = arrTemp;
      }
      return objArr;
    },
    getList() {
      this.total = this.filesImage.length;
      this.perfilesImage = this.chunk(this.filesImage, this.listQuery.pageSize);
    },
    openImage(url) {
      this.srcList = [];
      this.srcList.push(url);
    },
    //获取 操作类型
    getType(data) {
      switch (data) {
        case 10:
          return "上传文件";
          break;
        case 20:
          return "编辑材料";
          break;
        case 30:
          return "删除材料";
          break;
        case 40:
          return "指定患者";
          break;
        case 50:
          return "上传文件组";
          break;
      }
    },
    //患者来源
    getSource(data) {
      switch (data) {
        case 0:
          return "无";
          break;
        case 10:
          return "系统识别";
          break;
        case 20:
          return "手动指定";
          break;
        case 30:
          return "新患者";
          break;
      }
    },
    //状态
    getStatus(data) {
      switch (data) {
        case -70:
          return "待指定新患者";
          break;
        case -60:
          return "识别多张身份证";
          break;
        case 21:
          return "未分配援助方式";
          break;
        case -50:
          return "未识别患者信息";
          break;
        case -100:
          return "错误";
          break;
        case 0:
          return "初始化";
          break;
        case -40:
          return "重复患者";
          break;
        case 20:
          return "匹配中";
          break;
        case 30:
          return "已完成";
          break;
      }
    },
    initData() {
      groudetail(this.id).then(res => {
        this.fileGroup = res.data.fileGroup;
        this.files = res.data.files;
        console.log("this.files", this.files);
        this.filesImage = [];
        this.allCheck = [];
        this.AllphaseNum = 0;
        var entry = [];
        //得到所有的文件列表
        this.files.forEach(item => {
          this.AllphaseNum += item.fileNum;
          if (item["items"] && item["items"].length) {
            item["items"].forEach(ele => {
              entry.push(ele);
              ele.subFiles.forEach(con => {
                this.filesImage.push(con);
              });
            });
          }
        });
        //展示的文件列表
        this.filesImage.sort((a, b) => {
          return b["createTime"] - a["createTime"];
        });
        this.total = this.filesImage.length;
        this.perfilesImage = this.chunk(
          this.filesImage,
          this.listQuery.pageSize
        );

        //去重条目并相加个数
        this.allCheck = [];
        for (let i of entry) {
          var a = this.allCheck.find(item => item["item"] == i["item"]);
          if (!a) {
            this.allCheck.push(i);
          } else {
            this.allCheck.forEach(ele => {
              if (ele["item"] == i["item"]) {
                ele.fileNum += i["fileNum"];
              }
            });
          }
        }
      });
    },

    //点击条目小按钮
    handleCheck(info) {
      this.clickCheck = info;
      this.beginscreening();
    },
    //点击阶段小按钮
    handlePhase(info) {
      this.clickPhase = info;
      this.beginscreening();
    },
    //筛选当前的文件
    beginscreening() {
      this.filesImage = [];
      if (this.clickPhase == "全部") {
        if (this.clickCheck == "全部") {
          this.files.forEach(item => {
            if (item["items"] && item["items"].length) {
              item["items"].forEach(ele => {
                ele.subFiles.forEach(con => {
                  this.filesImage.push(con);
                });
              });
            }
          });
        } else {
          this.files.forEach(item => {
            item.items.forEach(name => {
              if (name.item == this.clickCheck) {
                this.filesImage.push(...name.subFiles);
              }
            });
          });
        }
      } else {
        var nowPase = [];
        this.files.forEach(item => {
          if (
            item.phase == this.clickPhase.phase &&
            item.times == this.clickPhase.times
          ) {
            nowPase.push(item);
          }
        });
        if (this.clickCheck == "全部") {
          nowPase.forEach(item => {
            if (item["items"] && item["items"].length) {
              item["items"].forEach(ele => {
                ele.subFiles.forEach(con => {
                  this.filesImage.push(con);
                });
              });
            }
          });
        } else {
          nowPase[0].items.forEach(item => {
            if (item.item == this.clickCheck) {
              this.filesImage.push(...item.subFiles);
            }
          });
        }
      }
      this.total = this.filesImage.length;
      this.listQuery = {
        pageIndex: 1,
        pageSize: 10
      };
      this.perfilesImage = this.chunk(this.filesImage, this.listQuery.pageSize);
    },

    //年龄
    getAge(data) {
      var info = new Date().getTime() - data;
      return parseInt(info / 1000 / 365 / 60 / 60 / 24);
    }
  }
};
</script>
<style lang="scss" scoped>
.materia-watch-page {
  padding: 0 30px;
  .group-list {
    margin-bottom: 40px;
    .file-list {
      min-width: 320px;
    }
    .grid-content {
      line-height: 38px;
    }
    .grid-img-box {
      margin-top: 20px;
      line-height: 28px;
      p {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0px;
        i {
          margin-right: 6px;
        }
      }
    }
  }
}
</style>

<style lang="scss" >
.materia-watch-page {
  .tag-list-box {
    margin-right: 10px;
  }
  .tag-list-box1 {
    margin-right: 6px;
  }
}
</style>